import { render } from "./GradingScaleManagement.vue?vue&type=template&id=77da576e&scoped=true"
import script from "./GradingScaleManagement.vue?vue&type=script&lang=js"
export * from "./GradingScaleManagement.vue?vue&type=script&lang=js"

import "./GradingScaleManagement.vue?vue&type=style&index=0&id=77da576e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77da576e"]])

export default __exports__